<div class="home">
  <!-- TODO: 本物のデータにしたら stagger アニメーションさせてください -->

  @if (isLoaded$ | async) {
    <div>
      @if (favorites$ | async; as favorites) {
        <div class="favs">
          @if (!media.isActive('lt-md')) {
            @for (partition of favorites; track partition) {
              <div [@favoritesLoaded]="partition[1]">
                <div class="genre">{{ partition[0] }}（あいうえお順）</div>
                <mat-divider></mat-divider>
                <div class="spacer-fixed-vertical-24"></div>
                <div fxLayout="row wrap" fxLayoutGap="16px grid">
                  @for (favorite of partition[1]; track favorite) {
                    <div
                      fxFlex.sm="1 1 100%"
                      fxFlex.md="1 1 50%"
                      fxFlex.lg="1 1 20%"
                      fxFlex.xl="1 1 10%"
                      >
                      <div routerLink="../artists/{{ favorite.globalId }}" class="fav" matRipple>
                        @if (favorite.arsha) {
                          <img class="fav-arsha" [src]="favorite.arsha" />
                        }
                        @if (!favorite.arsha) {
                          <div
                            class="fav-arsha-empty"
                            fxLayout
                            fxLayoutAlign="center center"
                            >
                            {{ favorite.nameMain }}
                          </div>
                        }
                        <div fxLayout fxLayoutAlign="center center">
                          {{ favorite.nameMain }}
                        </div>
                      </div>
                    </div>
                  }
                </div>
              </div>
            }
            <app-copyright></app-copyright>
          }
          @if (media.isActive('lt-md')) {
            <div fxLayout="column" style="min-height: 86vh; width: 100%;">
              <app-sp-top fxLayout="column" fxFlex="grow"></app-sp-top>
              <app-copyright></app-copyright>
            </div>
          }
        </div>
      }
    </div>
  } @else {
    <app-progress-indicator></app-progress-indicator>
  }
</div>

